import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ItemForm from './item/ItemForm';
import CustomLoader from '../common/CustomLoader';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { drapcodeIcon } from '../../common/custom/icon-library';
import EnvironmentSelect from '../../common/formElements/EnvironmentSelect';
import ParentDocCard from '../common/ParentDocCard';

export class CollectionItemEdit extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version, collectionId, collectionName, itemId } = match.params;
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    actions.loadCollectionItem({
      projectId,
      collectionName,
      version,
      itemId,
      decryptFields: true,
    });
  }

  refreshItemForm = () => {
    const { match, actions } = this.props;
    const { projectId, version, collectionId, collectionName, itemId } = match.params;
    actions.loadCollectionItem({ projectId, collectionName, itemId, version });
  };

  render() {
    const { collections, actions, match, home, common } = this.props;
    const { projectId, collectionId, version } = match.params;
    const {
      loadProjectCollectionDetailPending,
      selectedCollection,
      selectedItem,
      deleteItemPending,
      saveCollectionItemPending,
      updateCollectionItemPending,
      loadItemDetailsPending,
    } = collections;

    if (loadItemDetailsPending || loadProjectCollectionDetailPending) {
      return (
        <CommonPageComponent parentClassName="collections-edit-collection-item">
          <div className="text-center">
            <CustomLoader
              loading={loadProjectCollectionDetailPending || loadItemDetailsPending}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }

    if (!selectedCollection || !selectedItem) {
      return (
        <CommonPageComponent parentClassName="collections-edit-collection-item">
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('form')}`}></i>
                </div>
                <div className="card-title-header pt-3">
                  <div className="row">
                    <div className="col-6">
                      <h5 className="card-title">No data</h5>
                    </div>
                    <div className="col-6">
                      <EnvironmentSelect
                        projectId={projectId}
                        version={version}
                        refreshMethod={() => this.refreshItemForm()}
                        environment={collections.projectDetails}
                        actions={actions}
                      />
                    </div>
                  </div>
                </div>
                <div className="card-content">
                  <p>We do not have item data</p>
                </div>
              </div>
            </div>
            <ParentDocCard>
              <h5>About Collection Data</h5>
              <p>
                After creating the structure of a collection, you can either add, update or delete
                data manually or bring or edit it dynamically using the events like Save Data,
                Update Data & Delete Data. Data can also be transferred from other databases using
                data sources like Airtable, Firestore, MongoDB, Google Sheet, Firebase Realtime
                Database & REST API.
              </p>
              <br />
            </ParentDocCard>
          </div>
        </CommonPageComponent>
      );
    }

    const isShowDeleteLoader = deleteItemPending;
    const isShowCreateOrUpdateLoader = saveCollectionItemPending || updateCollectionItemPending;
    return (
      <CommonPageComponent parentClassName="collections-edit-collection-item">
        <ItemForm
          projectId={projectId}
          version={version}
          collection={selectedCollection}
          actions={actions}
          collections={collections}
          item={selectedItem}
          isShowDeleteLoader={isShowDeleteLoader}
          isShowCreateOrUpdateLoader={isShowCreateOrUpdateLoader}
          history={this.props.history}
          refreshItemForm={this.refreshItemForm}
          home={home}
          common={common}
        />
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionItemEdit);
